import { render, staticRenderFns } from "./StatisticsMarksByDepartmentsGenderAgeIndex.vue?vue&type=template&id=0898c108"
import script from "./StatisticsMarksByDepartmentsGenderAgeIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByDepartmentsGenderAgeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports